var _TextoPorTipo, _class, _temp2;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import t from 'prop-types';
import { TIPO_TEXTO, TIPO_NOTA, TIPO_VINCULO } from '../constantes';
import Texto from '../texto';
import TextoEditable from './texto-editable';
import NotaEditable from './nota-editable';
import VinculoEditable from './vinculo-editable';
var TextoPorTipo = (_TextoPorTipo = {}, _TextoPorTipo[TIPO_TEXTO] = TextoEditable, _TextoPorTipo[TIPO_NOTA] = NotaEditable, _TextoPorTipo[TIPO_VINCULO] = VinculoEditable, _TextoPorTipo);
var PanelTextos = (_temp2 = _class = function (_Component) {
  _inherits(PanelTextos, _Component);

  function PanelTextos() {
    var _temp, _this, _ret;

    _classCallCheck(this, PanelTextos);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleCrear = function (e) {
      var clientX = (e.changedTouches || e).clientX;
      var clientY = (e.changetTouches || e).clientY;

      var panelRect = _this.panel.getBoundingClientRect();

      var x = 100 * (clientX - panelRect.left) / panelRect.width;
      var y = 100 * (clientY - panelRect.top) / panelRect.height;
      var _this$props = _this.props,
          modoCrear = _this$props.modoCrear,
          config = _this$props.config,
          onCrear = _this$props.onCrear;
      onCrear && onCrear(modoCrear, x, y, config[modoCrear].textoAyuda);
    }, _this.renderTextos = function () {
      var _this$props2 = _this.props,
          textos = _this$props2.textos,
          minX = _this$props2.minX,
          maxX = _this$props2.maxX,
          modoCrear = _this$props2.modoCrear,
          tamFuenteBase = _this$props2.tamFuenteBase,
          config = _this$props2.config,
          onActualizar = _this$props2.onActualizar;
      return textos.map(function (texto) {
        if (Texto.esVacio(texto)) {
          return null;
        }

        var TextoUsuario = TextoPorTipo[texto.tipo];
        return React.createElement(TextoUsuario, {
          key: texto.id,
          texto: texto,
          tamFuenteBase: tamFuenteBase,
          minX: minX,
          maxX: maxX,
          activo: !modoCrear,
          config: config[texto.tipo],
          onActualizar: onActualizar
        });
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  PanelTextos.prototype.render = function render() {
    var _this2 = this;

    if (this.props.modoCrear) {
      var stylePanelCrearTextos = {
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(20, 20, 20, 0.2)',
        pointerEvents: 'auto'
      };
      return React.createElement('div', {
        style: stylePanelCrearTextos,
        onClick: this.handleCrear,
        ref: function ref(panel) {
          return _this2.panel = panel;
        }
      }, this.renderTextos());
    }

    return this.renderTextos();
  };

  return PanelTextos;
}(Component), _class.defaultProps = {
  textos: [],
  minX: 1,
  maxX: 99,
  modoCrear: false,
  tamFuenteBase: 14
}, _temp2);
PanelTextos.propTypes = process.env.NODE_ENV !== "production" ? {
  textos: t.arrayOf(t.shape({
    id: t.string.isRequired,
    tipo: t.string.isRequired,
    x: t.number.isRequired,
    y: t.number.isRequired,
    textoHtml: t.string.isRequired
  })),
  minX: t.number,
  maxX: t.number,
  tamFuenteBase: t.number,
  // textoAyuda: t.string.isRequired,
  config: t.object.isRequired,
  modoCrear: t.bool,
  onCrear: t.func.isRequired,
  onActualizar: t.func.isRequired
} : {};
export default PanelTextos;